import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from "@ngrx/store";
import { ReleaseNotesPageActions, ReleaseNotesApiActions } from "../actions";
import { IReleaseNotes } from "@skills-app/models/release-notes";
import { HomePageActions } from "@skills-app/home/Actions";

export interface IReleaseNotesLoading {
  readonly shownReleaseNotes: boolean;
  readonly releaseNotesTotalCount: boolean;
  readonly selectedReleaseNote: boolean;

  // This is used in your reducer below
  readonly latestReleaseNotes: boolean;
}

const initialLoadingState: IReleaseNotesLoading = {
  shownReleaseNotes: false,
  releaseNotesTotalCount: false,
  selectedReleaseNote: false,
  latestReleaseNotes: false,
};

export interface IReleaseNotesState {
  loading: IReleaseNotesLoading;
  releaseNotesTotalCount: number;
  latestReleaseNotes: IReleaseNotes[];
  selectedReleaseNote: IReleaseNotes | null;
}

const initialState: IReleaseNotesState = {
  loading: initialLoadingState,
  selectedReleaseNote: null,
  releaseNotesTotalCount: 0,
  latestReleaseNotes: [],
};

export const reducer = createReducer(
  initialState,

  on(ReleaseNotesPageActions.requestReleaseNotesPage, (state) => ({
    ...state,
    loading: { ...state.loading, shownReleaseNotes: true },
  })),

  on(ReleaseNotesPageActions.notesAddedSuccess, (state) => ({
    ...state,
    loading: { ...state.loading, shownReleaseNotes: false },
  })),

  on(ReleaseNotesPageActions.requestTotalReleaseNotesCount, (state) => ({
    ...state,
    loading: { ...state.loading, releaseNotesTotalCount: true },
  })),

  on(ReleaseNotesPageActions.countAddedSuccess, (state, action) => ({
    ...state,
    releaseNotesTotalCount: action.length,
    loading: { ...state.loading, releaseNotesTotalCount: false },
  })),

  on(ReleaseNotesPageActions.selectReleaseNote, (state, action) => ({
    ...state,
    selectedReleaseNote: action.releaseNote,
    loading: { ...state.loading, selectedReleaseNote: true },
  })),

  on(ReleaseNotesPageActions.clearSelectedReleaseNote, (state) => ({
    ...state,
    selectedReleaseNote: null,
  })),

  on(HomePageActions.loadPage, (state) => ({
    ...state,
    loading: { ...state.loading, latestReleaseNotes: true },
  })),

  on(ReleaseNotesApiActions.getLatestReleaseNotesSuccess, (state, action) => ({
    ...state,
    latestReleaseNotes: action.latestNotes,
    loading: { ...state.loading, latestReleaseNotes: false },
  })),

  on(ReleaseNotesApiActions.getLatestReleaseNotesError, (state) => ({
    ...state,
    loading: { ...state.loading, latestReleaseNotes: false },
  })),
);

export const getReleaseNotesState =
  createFeatureSelector<IReleaseNotesState>("releaseNotes");

export const getReleaseNoteLoading = createSelector(
  getReleaseNotesState,
  (releaseNotesState) => releaseNotesState.loading,
);

export const getReleaseNotesTotalCount = createSelector(
  getReleaseNotesState,
  (releaseNotesState) => releaseNotesState.releaseNotesTotalCount,
);

export const getLatestNotes = createSelector(
  getReleaseNotesState,
  (releaseNotesState) => releaseNotesState.latestReleaseNotes,
);

export const getSelectedReleaseNote = createSelector(
  getReleaseNotesState,
  (releaseNotesState) => releaseNotesState.selectedReleaseNote,
);
